import { defaultAxios } from '@/services';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

// GetFeedbackCount
type GetFeedbackCountParams = { filter: StructuredFilter };
type GetFeedbackCountResponse = number;
type GetFeedbackCountFunction = (
  params: GetFeedbackCountParams,
) => Promise<GetFeedbackCountResponse>;

// GET 네이밍 컨벤션을 따르지만 실제로는 POST 메서드를 사용 (filter payload가 body에 전달됨)
export const getFeedbackCount: GetFeedbackCountFunction = ({ filter }) => {
  const wa = getCurrWorkspaceAlias();
  return defaultAxios
    .post<FetchCountRes>(`/workspaces/${wa}/feedbacks/count`, filter)
    .then((res) => res.data.count);
};
